import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { getUtmObject } from 'reactApp/appHelpers/settingsHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';

export const sendNestleLandingTmrGoal = (goal: string, data?: Record<string, string>) => {
    if (window._tmr) {
        window._tmr.push({ id: '3684105', type: 'reachGoal', goal, ...data });
    }
};

export const sendNestleLandingAnalytics = ({
    eventCategory,
    action,
    ...rest
}: {
    eventCategory: string;
    action?: string;
    [key: string]: unknown;
}) => {
    const utms = getUtmObject();
    const state = reduxStore.getState();
    const isAnonymous = UserSelectors.isAnonymous(state);

    const dwhData = {
        auth: isAnonymous ? 0 : 1,
        landing_name: 'pereklichka_po_klichkam',
        platform: IS_PHONE_BROWSER ? String(EnvironmentSelectors.getMobileType()).toLowerCase() : 'desktop',
        action,
        ...rest,
        ...utms,
    };

    sendDwh({ eventCategory, dwhData, p: 'landing' });
};

export const sendNestleLandingSnitch = (event: string, data?: Record<string, string | number>) => {
    window?.snitch(event, data);
};
